import React from 'react';
import { set } from 'dot-prop-immutable';
import { connect } from 'react-redux';
import { getParentFormWidthChildren } from '@whalecloud/page-builder-core/selectors';
import { toolFormAttr, toolCollapseAttr, getLocale } from '@utils/util';
import { SimpleForm as Form, Collapse, Switch, Select } from '@whalecloud/fdx';
import CustomInput from '@whalecloud/page-builder-base-components/components/CustomInput';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';

const { Panel } = Collapse;
const { Option } = Select;

const valueKey = 'data.formItemSettings';

const SliderSettings = (props: any) => {
  const messages = getLocale();
  
  const { formElement, updateElement, element } = props;
  const { data: { formItemSettings = {}, formSettings = {} } = {} } = element;
  const { name } = formSettings;
  const {
    defaultValue,
    max = 100,
    min = 0,
    step = 1,
    dots = false,
    range = false,
    reverse = false,
    tooltipVisible = true,
    tooltipPlacement = 'top',
  } = formItemSettings;

  const initialValues = {
    defaultValue: Array.isArray(defaultValue) ? defaultValue.join(',') : JSON.stringify(defaultValue),
    max,
    min,
    step,
    dots,
    range,
    reverse,
    tooltipVisible,
    tooltipPlacement,
  };

  const handleInitialValues = (name, value) => {
    if (formElement) {
      const propName = `data.formSettings.initialValues.${name}`;
      const newElement = set(formElement, propName, value);
      updateElement({
        element: newElement,
      });
    }
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      let newElement = set(element, propName, obj[key]);
      if (key === 'defaultValue') {
        let relValue = obj[key].split(',');
        if (range) {
          const arr: any[] = [];
          relValue.forEach((val: any) => {
            arr.push(parseFloat(val));
          });
          relValue = arr;
        } else {
          relValue = parseFloat(relValue[0]);
        }
        newElement = set(element, propName, relValue);
        handleInitialValues(name, relValue);
      }
      if (key === 'range' && obj[key] && defaultValue && !Array.isArray(defaultValue)) {
        newElement = set(newElement, `${valueKey}.defaultValue`, [0, defaultValue]);
        handleInitialValues(name, [0, defaultValue]);
      }
      updateElement({
        element: newElement,
      });
    });
  };
  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1']}>
      <Panel header={messages.PAGEBUIDER_SETTINGS} key="1">
        <CommonItemSettings placeholderHide defaultValueHide allowClearHide />
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_DEFAULT_VALUE} name="defaultValue">
            <CustomInput inputProps={{ placeholder: messages.PAGEBUIDER_SETTINGS_PLACEHOLDER_DEFAULT_VALUE }} />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_MAX} name="max">
            <CustomInput inputType="inputNumber" />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_MIN} name="min">
            <CustomInput inputType="inputNumber" />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_STEP} name="step">
            <CustomInput inputType="inputNumber" />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_DOTS} name="dots" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_RANGE} name="range" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_REVERSE} name="reverse" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_TOOLTIP} name="tooltipVisible" valuePropName="checked">
            <Switch />
          </Form.Item>
          {
            tooltipVisible && (
              <Form.Item label={messages.PAGEBUIDER_SETTINGS_PLACEMENT} name="tooltipPlacement" valuePropName="checked">
                <Select>
                  <Option value="top">{messages.PAGEBUIDER_SETTINGS_PLACEMENT_TOP}</Option>
                  <Option value="left">{messages.PAGEBUIDER_SETTINGS_PLACEMENT_LEFT}</Option>
                  <Option value="right">{messages.PAGEBUIDER_SETTINGS_PLACEMENT_RIGHT}</Option>
                  <Option value="bottom">{messages.PAGEBUIDER_SETTINGS_PLACEMENT_BOTTOM}</Option>
                  <Option value="topLeft">{messages.PAGEBUIDER_SETTINGS_PLACEMENT_TOPLEFT}</Option>
                  <Option value="topRight">{messages.PAGEBUIDER_SETTINGS_PLACEMENT_TOPRIGHT}</Option>
                  <Option value="bottomLeft">{messages.PAGEBUIDER_SETTINGS_PLACEMENT_BOTTOMLEFT}</Option>
                  <Option value="bottomRight">{messages.PAGEBUIDER_SETTINGS_PLACEMENT_BOTTOMRIGHT}</Option>
                  <Option value="leftTop">{messages.PAGEBUIDER_SETTINGS_PLACEMENT_LEFTTOP}</Option>
                  <Option value="leftBottom">{messages.PAGEBUIDER_SETTINGS_PLACEMENT_LEFTBOTTOM}</Option>
                  <Option value="rightTop">{messages.PAGEBUIDER_SETTINGS_PLACEMENT_RIGHTTOP}</Option>
                  <Option value="rightBottom">{messages.PAGEBUIDER_SETTINGS_PLACEMENT_RIGHTBOTTOM}</Option>
                </Select>
              </Form.Item>
            )
          }
        </Form>
      </Panel>
    </Collapse>
  );
};

export default connect<any, any, any>(
  (state, { element }) => ({ formElement: getParentFormWidthChildren(state, element.id) }))(SliderSettings);
